import { useScrollReveal } from '@/hooks/useScrollReveal';

const qualifiedCriteria = [
  'клиент заинтересован в продукте или услуге;',
  'подходит по согласованной географии;',
  'соответствует вашему целевому сегменту;',
  'оставил актуальный контакт;',
  'подтвердил потребность;',
  'передаётся с историей общения.',
];

const notQualifiedCriteria = [
  'дубли;',
  'неверные контакты;',
  'спам;',
  'соискателей и поставщиков;',
  'обращения вне вашей географии или продукта;',
  'заявки, не прошедшие согласованные критерии.',
];

export default function LTKLeadCriteria() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 100 });
  const { ref: descRef, revealed: descRevealed } = useScrollReveal({ delay: 150 });
  const { ref: qualifiedRef, revealed: qualifiedRevealed } = useScrollReveal({ delay: 250 });
  const { ref: notQualifiedRef, revealed: notQualifiedRevealed } = useScrollReveal({ delay: 350 });

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <span ref={labelRef} className={`text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}>
            Прозрачность
          </span>
          <h2 ref={titleRef} className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}>
            Фиксируем правила до старта — без споров по заявкам
          </h2>
          <p ref={descRef} className={`mt-3 text-[15px] text-foreground-500 max-w-xl mx-auto reveal-fade-up ${descRevealed ? 'revealed' : ''}`}>
            Заранее определяем, что считается целевой заявкой, а что нет. Прозрачные критерии для обеих сторон.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          <div ref={qualifiedRef} className={`rounded-2xl bg-background-100 border border-background-200/70 p-7 md:p-9 reveal-fade-up ${qualifiedRevealed ? 'revealed' : ''}`}>
            <div className="flex items-center gap-3 mb-5">
              <span className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center">
                <i className="ri-check-double-line text-primary-600 text-lg"></i>
              </span>
              <h3 className="font-display font-bold text-[18px] text-foreground-950">Считаем заявкой</h3>
            </div>
            <ul className="space-y-3">
              {qualifiedCriteria.map((c) => (
                <li key={c} className="flex items-start gap-3">
                  <span className="w-5 h-5 rounded-full bg-primary-100 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-check-line text-primary-500 text-xs"></i>
                  </span>
                  <span className="text-[15px] text-foreground-700">{c}</span>
                </li>
              ))}
            </ul>
          </div>

          <div ref={notQualifiedRef} className={`rounded-2xl bg-background-100 border border-background-200/70 p-7 md:p-9 reveal-fade-up ${notQualifiedRevealed ? 'revealed' : ''}`}>
            <div className="flex items-center gap-3 mb-5">
              <span className="w-9 h-9 rounded-lg bg-secondary-100 flex items-center justify-center">
                <i className="ri-close-circle-line text-secondary-600 text-lg"></i>
              </span>
              <h3 className="font-display font-bold text-[18px] text-foreground-950">Не считаем заявкой</h3>
            </div>
            <ul className="space-y-3">
              {notQualifiedCriteria.map((c) => (
                <li key={c} className="flex items-start gap-3">
                  <span className="w-5 h-5 rounded-full bg-secondary-100 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-close-line text-secondary-500 text-xs"></i>
                  </span>
                  <span className="text-[15px] text-foreground-700">{c}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}